import { Authenticator } from '@amzn/awscat-portal-authentication-library';
import { ButtonDropdownProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';


export const getFeedbackDropDownItems = (auth: Authenticator): ButtonDropdownProps.ItemOrGroup[] => {
    const dropdownItems: ButtonDropdownProps.ItemOrGroup[] = [];
    if (auth.isAuthenticated()) {
        dropdownItems.push(
            {id: 'provideFeedback', text: constants.FEEDBACK_PROVIDE_FEEDBACK},
            {id: 'suggestAFeature', text: constants.FEEDBACK_SUGGEST_A_FEATURE},
            {id: 'submitABug', text: constants.FEEDBACK_SUBMIT_A_BUG},
        );
    }
    
    return dropdownItems;
};
